<template>
  <div class="create-post-comp">
    <div class="d-flex align-items-center mb-5 mob-shadow">
      <font-awesome-icon :icon="['far', 'arrow-left']" class="cp gray400 mr-4" @click="changeScreen('back')" />
      <h4 class="fw700 font24 gray700 ml-1 mb-0">Create a poll</h4>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="font-black ml-auto cp font20" @click="hide" />
    </div>

    <!-- ADDING IMAGES -->
    <template v-if="addingImages">
      <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">Loading image...</div>
      </div>
      <div v-else-if="!fileList.length && !isImageUploading" class="imageContainer">
        <!-- <font-awesome-icon
          :icon="['far', 'times']"
          class="font-white position-absolute bg-gray900 p-1 rounded-circle ar1 font20"
          :style="{ top: '10px', right: '10px', opacity: 0.6, 'z-index': 10 }"
          @click.stop="handleCancelImage(true)"
        /> -->
        <font-awesome-icon :icon="['far', 'plus']" :style="{ color: getPrimaryColor() }" />
        <p class="my-1 fw700 font14" :style="{ color: getPrimaryColor() }">Add Image</p>
        <p class="gray500 font12 mb-0 hide-in-mobile">or drag and drop</p>
        <input class="h-100 w-100 camera-icon-inp" type="file" accept="image/png, image/jpeg, image/gif, image/svg+xml" ref="fileInput" @change="handleImageUpload" :style="{ right: 0 }" title="" />
      </div>
      <div class="position-relative" v-else>
        <font-awesome-icon
          :icon="['far', 'times']"
          class="gray500 position-absolute bg-gray100 p-1 ar1 font20 rounded-circle cp"
          :style="{ top: '10px', right: '10px', 'z-index': 10 }"
          @click="handleRemoveImage"
        />
        <!-- @click="handleCancelImage" -->
        <img v-if="fileList.length" :src="fileList[0].url" />
      </div>
    </template>

    <p class="fw700 mb-1 font16 gray500 mt-4">Poll Question</p>
    <a-input class="pollInputBox gray900 m-w-auto" placeholder="Ask a Question" v-model="pollQuestion" />
    <p class="fw700 mb-1 font16 gray500 mt-4">Poll Choices</p>
    <div class="d-flex align-items-center mb-4" v-for="(choice, ind) in pollChoices" :key="ind">
      <a-input class="pollInputBox gray900" v-model="pollChoices[ind].choice_text" :placeholder="`Choice ${ind + 1}`" />
      <font-awesome-icon :icon="['fas', 'trash']" class="error300 cp ml-3" @click="deleteChoice(ind)" />
    </div>
    <p class="mb-0 fw700 font14 cp" :style="{ color: getPrimaryColor() }" @click="handleAddChoice" v-if="pollChoices.length < 4">Add new choice</p>
    <p class="fw700 mb-1 font16 gray500 mt-4">Poll Duration</p>
    <a-select :allowClear="true" showSearch :size="'large'" v-model="selectedDuration" class="w-100 newPostSelect m-w-auto" placeholder="" :showArrow="false" :filterOption="false">
      <a-select-option v-for="duration in typesOfPollDurations" :key="duration" :value="duration" class="p-2 font16 gray400">
        {{ duration }}
      </a-select-option>
    </a-select>
    <div class="br6 p1224 mt-5 ml-auto cp font-white" :style="{ width: 'fit-content', background: getPrimaryColor() }" @click="handleAddPoll">Done</div>
  </div>
</template>

<script>
import s3Upload from "../../../utilities/imageUploader"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PollScreen",
  props: {
    changeScreen: Function,
    getData: Function,
    handleCancelImage: Function,
    pollData: Object,
    addingImages: Boolean,
    hide: Function,
  },
  data() {
    return {
      pollQuestion: "",
      selectedDuration: "Forever",
      pollChoices: [
        { choice_text: "", correct: false },
        { choice_text: "", correct: false },
      ],
      typesOfPollDurations: ["1 day", "3 days", "1 week", "2 weeks", "Forever"],
      isImageUploading: false,
      fileList: [],
      post_attach: [],
    }
  },
  created() {
    if (this.pollData) {
      this.pollChoices =
        this.pollData.choices && this.pollData.choices.length
          ? this.pollData.choices
          : [
              { choice_text: "", correct: false },
              { choice_text: "", correct: false },
            ]
      this.pollQuestion = this.pollData.title || ""
      this.selectedDuration = this.pollData.pollDuration || "Forever"
      this.fileList = this.pollData.img || []
    } else {
      this.pollChoices = [
        { choice_text: "", correct: false },
        { choice_text: "", correct: false },
      ]
      this.pollQuestion = ""
      this.selectedDuration = "Forever"
      this.fileList = []
    }
  },
  watch: {
    addingImages: {
      handler(v) {
        if (!v) {
          this.fileList = []
          this.isImageUploading = false
          this.post_attach = []
        }
      },
    },
  },
  methods: {
    handleRemoveImage() {
      this.fileList = []
    },
    handleAddPoll() {
      let dupChoice = false
      let choiceArr = []
      this.pollChoices.forEach(c => {
        if (!dupChoice && c.choice_text) {
          if (choiceArr.includes(c.choice_text)) {
            dupChoice = true
          } else {
            choiceArr.push(c.choice_text)
          }
        }
      })

      if (dupChoice) {
        this.$notification.error({ message: "Error", description: "There cannot be duplicate choices" })
      } else if (this.pollQuestion.trim().length && this.pollChoices[0].choice_text && this.pollChoices[1].choice_text) {
        this.getData({ choices: this.pollChoices.filter(c => c.choice_text), title: this.pollQuestion, pollDuration: this.selectedDuration, img: this.fileList }, "poll")
      } else {
        this.$notification.error({ message: "Error", description: "Provide the required fields to create a new poll." })
      }
    },

    handleAddChoice() {
      if (this.pollChoices.length === 4) {
        this.$notification.error({ message: "Error", description: "Maximum 4 choices allowed." })
        return
      }
      this.pollChoices = [...this.pollChoices, { choice_text: ``, correct: false }]
    },

    deleteChoice(i) {
      if (this.pollChoices.length > 2) {
        const pollList = [...this.pollChoices]
        pollList.splice(i, 1)
        this.pollChoices = pollList
      } else {
        this.$notification.error({ message: "Error", description: "Minimum two choices are required" })
      }
    },

    async handleImageUpload() {
      if (this.fileList.length) {
        this.$notification.error({ message: "Error", description: "Cannot add more than one image" })
      } else {
        const file = this.$refs.fileInput.files[0]
        this.isImageUploading = true
        if (file.size / (1024 * 1024) > 5) {
          this.$notification.error({ message: "Error", description: "File size exceeds 5MB limit" })
        } else if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image.",
          })
        } else {
          try {
            const urlData = await UserRepository.getPresignedUrl({ file_name: [file.name] })
            const fileName = urlData.data.data.filename[0]
            await s3Upload(urlData.data.data.url[0], file)
            this.post_attach.push(fileName)
            const fileListData = { name: fileName, url: urlData.data.data.preview_url }
            this.fileList.push(fileListData)
          } catch (err) {}
        }
        this.isImageUploading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.imageContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  background: #f8fafd;
  border: 1px dashed #94a3b8;
  border-radius: 6px;
  cursor: pointer;
  min-height: 171px;
  position: relative;
}
img {
  // max-width: 507px;
  max-height: 278px;
  background-size: contain;
  object-fit: contain;
  background: white;
  width: 100%;
}
.pollInputBox {
  padding: 12px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  height: 56px;
  font-size: 16px;
  line-height: 32px;
  // color: #94a3b8;
}
@media screen and (max-width: 600px) {
  .mob-shadow {
    margin-left: -10px;
    margin-right: -10px;
  }
  .newPostSelect {
    width: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/Poll.vue